module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Music-9528553d7724c9461746b699b878ab23.svg";